import {put, takeEvery, select, call} from 'redux-saga/effects';
import {isVisible as isVisibleSelector} from 'selectors/visibilityMenu/visibilityMenu';
import {visibilityMenu} from 'actions/menu/mainMenu';
import {toggleMenu, toggleSearch} from 'reducers/header/header';
import {isQuickSearchVisible} from 'selectors/quickSearch/quickSearch';
import {setQuickSearchVisibility} from 'reducers/quickSearch/quickSearch';
import {disableScroll} from 'libs/disableScroll';
import {QUOTE_ITEM} from 'constants/actions';
import {getActiveCartItemsCount} from 'selectors/cart/cart';
import {POST_MESSAGE_TYPES, postMessage} from 'libs/postMessage/postMessage';

/**
 * Menu Toggle Action Handler
 */
export function* onToggleMenuDispatched() {
    const isVisible = yield select(isVisibleSelector);
    yield put(visibilityMenu(!isVisible));
}

/**
 * Search Toggle Action Handler
 */
export function* onToggleSearchDispatched() {
    const isSearchVisible = yield select(isQuickSearchVisible);
    yield call(disableScroll, !isSearchVisible, true, true);

    yield put(setQuickSearchVisibility(!isSearchVisible));
}

/**
 * Updates the count of cart items in the header
 */
export function* updateHeaderCartBadge() {
    const count = yield select(getActiveCartItemsCount);
    yield call(postMessage, {type: POST_MESSAGE_TYPES.CART_UPDATE_ITEMS_COUNT, data: count});
}

/**
 * Header Saga
 */
export function* headerSaga() {
    yield takeEvery(toggleMenu, onToggleMenuDispatched);
    yield takeEvery(toggleSearch, onToggleSearchDispatched);
    yield takeEvery(`${QUOTE_ITEM.GET_ITEMS}_FULFILLED`, updateHeaderCartBadge);
}
